var globalHttpNumber = 0;


/**
 * Global ajax http request to manage all new call with spinner effect
 * @param {string} url - url to call
 * @param {string} [method=GET] - method to use for ajax - default GET type
 * @param {string} [dataType] - dataType params
 * @param {object} [data] - Object
 */
export function globalHttpRequest (url, method, dataType, data) {
    var defer = jQuery.Deferred();

    if (!url) {
        defer.reject('URL MISSING');
        return defer.promise();
    }

    globalHttpNumber++;
    var setting = {
        url: url,
        method: method || 'GET',
        success: function (response) {
            globalHttpNumber--;
            if (globalHttpNumber === 0) {
                $.spinner().stop();
            }
            defer.resolve(response);
        },
        error: function (error) {
            globalHttpNumber--;
            if (globalHttpNumber === 0) {
                $.spinner().stop();
            }
            defer.reject(error);
        }
    };

    setting.dataType = null;
    setting.data = null;

    if (dataType) {
        setting.dataType = dataType;
    }
    if (data) {
        setting.data = data;
    }

    $.spinner().start();
    $.ajax(setting);

    return defer.promise();
}
